class SnExpandGroup extends HTMLElement{
    constructor(){
        super();
    }
    get ItemListing(){
        return this.querySelectorAll('sn-expand-item');
    }
    get containerWidth(){
        return parseInt(this.getBoundingClientRect().width);
    }
    get spacingItem(){
        return parseInt(window.getComputedStyle(this).getPropertyValue('--spacing-dk').trim());
    }
    get itemCount(){
        return parseInt(this.querySelectorAll('sn-expand-item').length || 0);
    }
    initStyle(){
       let item_w = ((this.containerWidth - (this.itemCount - 1) * this.spacingItem) / (this.itemCount + 1));
        this.ItemListing.forEach(element => {
            element.querySelector('.sn-ep-pr')?.style.setProperty('max-width', `${item_w}px`);
        });
    }
    connectedCallback(){
        if(window.innerWidth > 1150){
            this.initStyle();
        }
    }
    disconnectedCallback(){

    }
    init(){

    }
    setupEventListiner(){

    }
    handleHover(){

    }
}
customElements.define('sn-expand-group', SnExpandGroup);

function detectDevice() {
  const ua = navigator.userAgent;
  const isIpad = /iPad|Macintosh/.test(ua) && Array.prototype.substr && navigator.maxTouchPoints > 1;
  const isAndroidTablet = /Android/.test(ua) && !/Mobile/.test(ua);
  
  const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;

  if (isIpad || isAndroidTablet || (isTouchDevice && window.innerWidth > 768)) {
    return "tablet";
  }
  
  return "not-tablet";
}

// if (detectDevice() === "tablet") {
//   console.log("isTablet");
// }else{
//     console.log("not tablet");
// }

class SnExpandItem extends HTMLElement{
    constructor(){
        super();
        this.parent = this.closest('sn-expand-group');
        this.btn = this.querySelector('[handle-wap]');
    }
    get allVideo(){
        return this.parent?.querySelectorAll('video') || [];
    }
    get isActive(){
        return this.hasAttribute('is-active') || false;
    }
    get videos(){
        return this.querySelectorAll('video') || null;
    }
    get closeOtherItems(){
        return this.parent?.hasAttribute('close-items-open') || false;
    }
    get productURL(){
        return this.getAttribute('data-url') || '';
    }
    connectedCallback(){
        this.setupEventListiner();
        this.init();
    }
    disconnectedCallback(){

    }
    init(){
        if(this.isActive){
            this.playVideos();
        }
    }
    setupEventListiner(){
       if(window.innerWidth > 1150 && detectDevice() !== 'tablet'){
            this.addEventListener('mouseenter', this.handleHover.bind(this));
       }
       if(window.innerWidth < 1149){
            this.btn.addEventListener('click', this.handleClick.bind(this));
       }
       if(window.innerWidth > 1150 && detectDevice() === "tablet"){
            this.addEventListener('click', this.handleTabletClick.bind(this));
       }
    }
    handleHover(e){
        if(this.isActive)return;
        this.playVideos();
        this.parent.querySelector('[is-active]')?.removeAttribute('is-active');
        this.setAttribute('is-active', '');
    }
    handleClick(){
        if(this.isActive){
            this.removeAttribute('is-active');
        }else{
            if(this.closeOtherItems){
                this.parent?.querySelectorAll('sn-expand-item[is-active]').forEach(element => {
                    if(element !== this){
                        element.removeAttribute('is-active');
                    }
                });
            }
            this.setAttribute('is-active', '');
            this.playVideos();
        }
    }
    handleTabletClick(e){
        e.preventDefault();
        e.stopPropagation();
        if(this.isActive && this.productURL){
            window.location.href = this.productURL;
        }else{
            if(this.closeOtherItems){
                this.parent?.querySelectorAll('sn-expand-item[is-active]').forEach(element => {
                    if(element !== this){
                        element.removeAttribute('is-active');
                    }
                });
            }
            this.setAttribute('is-active', '');
            this.playVideos();
        }
        
    }
    async #safePlay(video) {
        if (!video || typeof video.play !== 'function') return;
        
        try {
            if (video.paused) {
                await video.play();
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error("Playing video:", error);
            }
        }
    }
    playVideos(){
        this.videos.forEach(video => {
            this.#safePlay(video);
        });
    }
}
customElements.define('sn-expand-item', SnExpandItem);